import styled, { css } from 'styled-components';


const getButtonVariantStyle = (theme, variant) => {
  if (variant === 'secondary') {
    return css`
      background: transparent;
      border: 2px solid ${theme.v3.colors.neutral[100]};
      box-shadow: none;
      color: ${theme.v3.colors.neutral[100]};
    `;
  }

  return css`
    background: ${theme.v3.colors.neutral[100]};
    border: none;
    box-shadow: 0 2px 10px 0 rgba(0, 18, 37, 0.15);
    color: ${theme.v3.colors.brand.snappyBlue[50]};
  `;
};

export const Card = styled.div`
  ${({ theme }) => css`
    align-items: center;
    background: linear-gradient(95deg, #0061A6 0%, #0082B8 20%, #26A3C5 40%, #56C2D0 60%, #87E1DA 80%, #B9FFE8 100%);
    border-radius: 24px;
    box-shadow: 0 4px 8px 0 rgba(223, 226, 235, 0.22), 0 3px 6px 0 rgba(223, 226, 235, 0.16);
    display: flex;
    font-family: ${theme.v3.font.family.brand};
    flex: 1 1 534px;
    flex-direction: row;
    height: 205px;
    max-width: 627px;
    overflow: hidden;
    padding: 28px 24px 24px;
    position: relative;
    width: 100%;

    @media (max-width: ${theme.v3.breakpoints.lg}) {
      flex-basis: 0;
      height: auto;
      max-width: 627px;
      min-height: 205px;
    }

    @media (max-width: ${theme.v3.breakpoints.md}) {
      align-items: flex-start;
      flex: none;
      height: auto;
      max-width: 100%;
      min-height: auto;
      padding: 31px 24px 24px;
      width: 100%;
    }

    @media (max-width: ${theme.v3.breakpoints.sm}) {
      height: auto;
      margin: 14px auto 0;
      max-width: 342px;
      min-height: auto;
      padding: 18px 16px 18px;
      width: 100%;
    }
  `}
`;

export const Content = styled.div`
  align-items: flex-start;
  display: flex;
  flex: 1;
  flex-direction: row;
  gap: 16px;
  min-width: 0;
  z-index: 1;

  @media (max-width: ${({ theme }) => theme.v3.breakpoints.md}) {
    gap: 8px;
  }
`;

export const ShieldIcon = styled.div`
  align-items: center;
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  margin-top: 2px;
`;

export const ShieldImage = styled.img`
  display: block;
  height: auto;
  max-width: 100%;
  object-fit: contain;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  min-width: 0;
`;

export const Title = styled.h3`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[100]};
    font-size: ${theme.v3.font.sizes['1xmedium']};
    font-weight: ${theme.v3.font.weights.medium};
    margin: 0 0 8px;
    text-shadow: 0 2px 10px rgba(0, 18, 37, 0.15);

    @media (max-width: ${theme.v3.breakpoints.sm}) {
      font-size: ${theme.v3.font.sizes.large};
      line-height: 150%;
      margin-bottom: 6px;
    }
  `}
`;

export const Description = styled.p`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[100]};
    font-size: ${theme.v3.font.sizes.small};
    font-weight: ${theme.v3.font.weights.medium};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    margin: 0 0 24px;
    max-width: 380px;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      font-size: ${theme.v3.font.sizes.small};
      margin-bottom: 32px;
    }

    @media (max-width: ${theme.v3.breakpoints.sm}) {
      font-size: ${theme.v3.font.sizes.small};
      line-height: 150%;
      margin-bottom: 16px;
      max-width: none;
    }
  `}
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;

  @media (max-width: ${({ theme }) => theme.v3.breakpoints.sm}) {
    width: 100%;
  }
`;

export const ActionButton = styled.button`
  ${({ theme, variant, hasMultipleButtons }) => css`
    align-items: center;
    border-radius: 20px;
    cursor: pointer;
    display: inline-flex;
    font-family: inherit;
    font-size: ${theme.v3.font.sizes.medium};
    font-weight: ${theme.v3.font.weights.medium};
    height: 40px;
    justify-content: center;
    line-height: ${theme.v3.font.lineHeight.comfortable};
    padding: 0 16px;
    transition: transform 0.1s ease;

    ${hasMultipleButtons && css`
      flex: 1;
      min-width: 189px;
      white-space: nowrap;
    `}

    ${getButtonVariantStyle(theme, variant)}

    &:active {
      transform: translateY(1px);
    }

    @media (max-width: ${theme.v3.breakpoints.md}) {
      border-radius: 20px;
      font-size: ${theme.v3.font.sizes.small};
      height: 40px;
      padding: 0 20px;
    }

    @media (max-width: ${theme.v3.breakpoints.sm}) {
      font-size: ${theme.v3.font.sizes.medium};
      line-height: 150%;

      ${hasMultipleButtons && css`
        width: 100%;
      `}
    }
  `}
`;

export const ActionButtonLink = styled(ActionButton).attrs({ as: 'a' })`
  text-decoration: none;
`;

export const MonarxIcon = styled.div`
  bottom: -2px;
  pointer-events: none;
  position: absolute;
  right: 0;
  z-index: 0;
`;

export const MonarxImage = styled.img`
  display: block;
  height: auto;
  max-width: 100%;
  object-fit: contain;
`;
